<button
	type="button"
	class="btn btn-transparent text-white position-relative"
	ngbTooltip="{{ 'GLOBAL_TOOLBAR.FULLSCREEN' | translate }}"
	(click)="onToggle()"
>
	<i class="bi bi-arrows-fullscreen"></i>
</button>
